import { render, staticRenderFns } from "./SearchCompany.vue?vue&type=template&id=078c67b0&scoped=true&"
import script from "./SearchCompany.vue?vue&type=script&lang=js&"
export * from "./SearchCompany.vue?vue&type=script&lang=js&"
import style0 from "./SearchCompany.vue?vue&type=style&index=0&id=078c67b0&scoped=true&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078c67b0",
  null
  
)

export default component.exports